import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { DomAvatarDisplay } from '../../avatars/domAvatarDisplay';
import { ExpandableSection } from '../../components/expandableSection';
import { IconWithLabelDisplay } from '../../components/iconWithLabelDisplay';
import { initNewAvatar, setIsAvatarEditorOpen } from '../../redux/actions/selfAvatarActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { SELF_PANEL_CONTENT_BACKGROUND_COLOR } from '../../styles/colors';
import { ALL_AVATAR_TYPE_PROPERTIES, AVATAR_TYPE_LABELS } from '../../types/avatarTypes';
import { isLocalhostEnvironment } from '../../utils/utils';
const SECTION_BODY_CSS = css `
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  gap: 5px;
`;
export const SelfAvatarStaticDisplay = () => {
    const dispatch = useAppDispatch();
    // TODO: Improve this inefficient selector:
    const savedPlayerAvatar = useAppSelector((state) => state.selfAvatar.avatar?.savedAvatar);
    const roomSceneType = useAppSelector((state) => state.scene.roomSceneType);
    // TODO: Improve this inefficient selector:
    const fetchedPlayerAvatar = useAppSelector((state) => state.selfData.fetchedSelfInfo?.playerAvatar);
    const onClickCreateAvatar = useCallback(() => {
        dispatch(initNewAvatar());
        dispatch(setIsAvatarEditorOpen(true));
    }, [dispatch]);
    const onClickEditAvatar = useCallback(() => {
        dispatch(setIsAvatarEditorOpen(true));
    }, [dispatch]);
    const getEditButton = useCallback(() => {
        if (roomSceneType !== 'poker') {
            return _jsx(IconWithLabelDisplay, { label: 'Editable in poker rooms', isSubtle: true });
        }
        if (savedPlayerAvatar && ALL_AVATAR_TYPE_PROPERTIES[savedPlayerAvatar.type].canEdit) {
            return (_jsx(Button, { onClick: onClickEditAvatar, variant: 'contained', children: "Edit" }));
        }
        if (savedPlayerAvatar && !ALL_AVATAR_TYPE_PROPERTIES[savedPlayerAvatar.type].canCreateCustomAvatar) {
            return null;
        }
        return (_jsx(Button, { onClick: onClickCreateAvatar, variant: 'contained', children: "Create" }));
    }, [onClickCreateAvatar, onClickEditAvatar, roomSceneType, savedPlayerAvatar]);
    const playerAvatar = savedPlayerAvatar || fetchedPlayerAvatar;
    return (_jsx(ExpandableSection, { title: playerAvatar ? AVATAR_TYPE_LABELS[playerAvatar.type] : 'Avatar', colorType: 'player-info', children: _jsxs("div", { css: SECTION_BODY_CSS, children: [playerAvatar && (_jsx(DomAvatarDisplay, { playerAvatar: playerAvatar, backgroundColor: SELF_PANEL_CONTENT_BACKGROUND_COLOR, 
                    // only open self image in modal on localhost for asset creation / editing purposes:
                    isClickable: isLocalhostEnvironment() })), _jsx("div", { children: getEditButton() })] }) }));
};
